export const normalizeCurrencyCode = (value: unknown): string | null => {
  if (typeof value !== 'string') return null
  const code = value.trim().toUpperCase()
  return /^[A-Z]{3}$/.test(code) ? code : null
}

export const currencyCacheKey = (key: string, code: unknown) =>
  `${key}__currency-${normalizeCurrencyCode(code) ?? 'default'}`

/** Currency rounding for indicative quotes, never payable totals or balances. */
export const roundQuotedPrice = (value: number, roundUp = 1) =>
  Number.isFinite(roundUp) && roundUp >= 1
    ? Math.ceil(value / roundUp) * roundUp
    : value

export const currencyMinorUnits = (amount: number, code: string) => {
  const precision =
    new Intl.NumberFormat('en', {
      style: 'currency',
      currency: code,
    }).resolvedOptions().maximumFractionDigits ?? 2
  return Math.round(amount * 10 ** precision)
}
